import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/Transition';
import {TweenLite, Power2} from 'gsap'
import LogoSpinner from './LogoSpinner'

const TRANSITION_DURATION_SECONDS = 0.2;

class Spinner extends PureComponent {

    _onEntering = (node) => {
        TweenLite.fromTo(node, TRANSITION_DURATION_SECONDS, {opacity: 0}, {opacity: 1, ease: Power2.easeInOut});
    }

    _onExiting = (node) => {
        TweenLite.to(node, TRANSITION_DURATION_SECONDS, {opacity: 0, ease: Power2.easeInOut } );
    }

    render() {
        const {className, show} = this.props;

        return <TransitionGroup appear={true} enter={true} exit={true}>
            {show &&
            <Transition timeout={TRANSITION_DURATION_SECONDS * 1000}
                        onEntering={this._onEntering}
                        onExiting={this._onExiting}>
                <div className={className}>
                    <LogoSpinner width="120" height="48" animate={true}/>
                </div>
            </Transition>
            }
        </TransitionGroup>
    }
}

export default injectSheet((theme) => (
    {
        spinnerContainer: {
            ...theme.font.link,
            display: "inline-block",
            position: "relative",
        },
    }
))(Spinner)





// WEBPACK FOOTER //
// ./src/components/Widgets/Spinner.js